var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88",
    "data-name": "Rectangle 88",
    width: 22,
    height: 22,
    transform: "translate(483 838)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_268",
    "data-name": "Mask Group 268",
    transform: "translate(-483 -838)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(481.701 836.625)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_301",
    "data-name": "Group 301"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M18.659,23.375H6.091a2.014,2.014,0,0,1-1.966-2.062V7.721H5.5V21.313A.639.639,0,0,0,6.091,22H18.659a.639.639,0,0,0,.591-.687V7.721h1.375V21.313A2.014,2.014,0,0,1,18.659,23.375Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M21.161,6.188H3.438a.687.687,0,1,1,0-1.375H21.161a.687.687,0,1,1,0,1.375Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M14.438,8.938h1.375V19.25H14.438Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M8.938,8.938h1.375V19.25H8.938Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M15.813,4.029H14.506V2.75H10.244V4.029H8.938V2.75a1.375,1.375,0,0,1,1.306-1.375h4.263A1.375,1.375,0,0,1,15.813,2.75Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.d39933dfbf9b855877b0985f1a6ebc9e.svg";
export { ForwardRef as ReactComponent };